// import axios from 'axios'

export default axios.create({
    // 统一走相对路径（同源域名与端口）；开发环境通过 devServer 代理到后端
    baseURL: '',
    timeout: 10000
})


// WEBPACK FOOTER //
// ./src/api/index.js